/* eslint-disable import/prefer-default-export */
import apiClient from '../utilities/api-client';

export const createCustomTerm = (data) => apiClient.post('/terms', data);

export const getTermsCategories = () => apiClient.get('/terms/categories');
